export default function PartnerCredibility() {
  const features = [
    'Durable',
    'Energy-efficient',
    'Multiple styles (double-hung, casement, sliding)',
    'Choice of colors/finishes'
  ];

  return (
    <section id="partner-credibility" className="py-24 bg-gradient-to-b from-[#F2F2F2] to-white">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            {/* Headline */}
            <h2 className="text-4xl md:text-5xl font-heading font-semibold text-[#2B6777] mb-6 tracking-tight leading-tight">
              Built with manufacturers you can trust
            </h2>

            {/* Body */}
            <p className="text-lg text-[#2B6777]/70 leading-relaxed mb-8">
              We partner with <strong className="font-semibold text-[#2B6777]">Alside</strong>, a trusted American manufacturer with <strong className="font-semibold text-[#2B6777]">72+ years</strong> of proven track record—because your warranty is only as good as the company behind it.
            </p>

            {/* Feature Bullets */}
            <div className="space-y-3">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#52AB98] rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <p className="text-base text-[#2B6777]">
                    {feature}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Logos + Visual */}
          <div className="relative">
            <div className="bg-white rounded-3xl p-12 shadow-lg border border-[#C8D8E4]/30">
              {/* Partner Logos */}
              <div className="flex items-center justify-center gap-8 mb-8 flex-wrap">
                {/* Kemp Logo */}
                <div className="text-center">
                  <img 
                    src="https://static.readdy.ai/image/a109cef237b31571116f6f567dd6e069/730a63bd9d8c35f428192b182c2ebc39.png" 
                    alt="Kemp Windows & Siding" 
                    className="h-20 w-auto mx-auto"
                  />
                </div>

                {/* Divider */}
                <div className="w-px h-16 bg-[#2B6777]/20"></div>

                {/* Alside Logo */}
                <div className="text-center">
                  <img 
                    src="https://static.readdy.ai/image/a109cef237b31571116f6f567dd6e069/72691a54d49a52524e97de07aae37003.png" 
                    alt="Alside" 
                    className="h-16 w-auto mx-auto mb-2"
                  />
                  <p className="text-sm text-[#2B6777]/60 uppercase tracking-wider">Since 1947</p>
                </div>
              </div>

              {/* Trust Badge */}
              <div className="bg-gradient-to-br from-[#52AB98]/10 to-[#2B6777]/10 rounded-2xl p-6 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <i className="ri-shield-check-line text-3xl text-[#52AB98]"></i>
                </div>
                <p className="text-lg font-semibold text-[#2B6777] mb-1">
                  72+ Years of Excellence
                </p>
                <p className="text-sm text-[#2B6777]/60">
                  American-made quality you can count on
                </p>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#F6D7DF]/30 rounded-full blur-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}